import { render, staticRenderFns } from "./BookSlider.vue?vue&type=template&id=125ec2ea&scoped=true&"
import script from "./BookSlider.vue?vue&type=script&lang=js&"
export * from "./BookSlider.vue?vue&type=script&lang=js&"
import style0 from "./BookSlider.vue?vue&type=style&index=0&id=125ec2ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125ec2ea",
  null
  
)

export default component.exports